import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { Lifecycle } from "gatsby-theme-gba"

const LifecycleEditable = ({ blok }) => {
  const data = blok.segments.map((segment) => {
    return {
      value: 10,
      color: segment.backgroundColor,
      label: segment.headline,
      url: segment.url.id,
      icon: segment.icon.filename,
      extraInfo: segment.extraInfo,
      extraInfoYPos: segment.extraInfoYPos,
      extraInfoXPos: segment.extraInfoXPos,
      flipText: !!segment.flipText,
    }
  })

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <Lifecycle
        baseWidth={parseFloat(blok.baseWidth)}
        baseHeight={parseFloat(blok.baseHeight)}
        currentLanguage={blok.currentLanguage}
        innerText={blok.description}
        innerRadiusRatio={parseFloat(blok.innerRadiusRatio)}
        iconRadiusRatio={parseFloat(blok.iconRadiusRatio)}
        data={data}
      />
    </div>
  )
}

export default LifecycleEditable
